import { CSSProperties } from 'react';
import { useReduxState } from 'hooks';

import type { User } from 'shared-types';

interface Props {
  owners: Pick<User, 'firstName' | 'lastName' | 'username'>[];
  style?: CSSProperties;
}

const Owners = ({ owners, style }: Props) => {
  const {
    messages,
    serverConfig: { userUseName }
  } = useReduxState();

  return (
    <div
      style={{ display: 'inline-block', ...style }}
      {...(owners && owners.length > 1
        ? {
            'aria-label':
              `${messages.commonOwners}: ` +
              owners
                .map((owner) =>
                  userUseName && owner.firstName && owner.lastName
                    ? `${owner.firstName} ${owner.lastName}`
                    : owner.username
                )
                .join(', '),
            'data-tooltip': owners
              .map((owner) =>
                userUseName && owner.firstName && owner.lastName
                  ? `${owner.firstName} ${owner.lastName}`
                  : owner.username
              )
              .join(', ')
          }
        : {})}
    >
      {owners && owners.length
        ? userUseName && owners[0].firstName && owners[0].lastName
          ? `${owners[0].firstName} ${owners[0].lastName}`
          : owners[0].username
        : 'No owner'}
      {owners && owners.length > 1 ? (
        <span>
          {` ${messages.commonAnd} ${owners.length - 1} ${
            messages.courseOthers
          }`}
        </span>
      ) : null}
    </div>
  );
};

export default Owners;
